import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Posts from "./pages/Posts";
import SinglePost from "./pages/SinglePost";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Service from "./pages/Service";
import NotFound from "./pages/NotFound";
import "./App.css";
import { Transition } from "./components/Transition/Transition";
import { AnimatePresence } from "framer-motion";

const AnimatedRoutes = () => {
  const location = useLocation(); // 👈 Get the current location

  return (
    <AnimatePresence mode="wait"> {/* 👈 Ensure exit animations work */}
      <Routes key={location.pathname} location={location}>  {/* 👈 Key ensures proper re-render */}
        <Route path="/" element={<Transition><Home /></Transition>} />
        <Route path="/about" element={<Transition><About /></Transition>} />
        <Route path="/contact" element={<Transition><Contact /></Transition>} />
        <Route path="/services" element={<Transition><Service /></Transition>} />
        <Route path="/gallery" element={<Transition><Gallery /></Transition>} />
        <Route path="/posts" element={<Transition><Posts /></Transition>} />
        <Route path="/post/:id" element={<Transition><SinglePost /></Transition>} />
        <Route path="*" element={<Transition><NotFound /></Transition>} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => {
  return (
    <Router>
      <Layout>
        <AnimatedRoutes /> {/* 👈 Use the new AnimatedRoutes component */}
      </Layout>
    </Router>
  );
};

export default App;
